import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Grid} from '@material-ui/core'
import {Button, FormControl, TextField, Checkbox } from '@material-ui/core';

class EditLogSettingsDialog_ extends React.Component{

    constructor(props){
        super(props)

        const {logSettings} = this.props; 
        this.state = {
            logSettings: logSettings,
            errors:{
                ClearDataDays: false,
                ClearRecordingDays: false
            },
            changed: false,
        }

        this.handleInput = this.handleInput.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    handleSave(){
        if(!this.checkErrors()){
            let logSettings = {...this.props.logSettings, ...this.state.logSettings}
            this.props.onAction({type: 'LOG_SETTINGS_EDITOR_SAVE', logSettings: logSettings})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'LOG_SETTINGS_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'LOG_SETTINGS_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        if(!this.state.changed) this.setState({changed: true})

        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value

        const logSettings = {...this.state.logSettings, [event.target.name]: val}

        const errors = this.validate(logSettings)

        this.setState({logSettings: logSettings, errors: errors})

    }

    validate(logSettings){

        let errors = this.state.errors;

        let validateClearData = /^\d+$/.test(logSettings.ClearDataDays);
        if(logSettings.ClearDataDays && !validateClearData){
            errors.ClearDataDays = this.props.t('IsNotInteger')
        }else{
            errors.ClearDataDays = false
        }

        let validateClearRecordingDays = /^\d+$/.test(logSettings.ClearRecordingDays);
        if(logSettings.ClearRecordingDays && !validateClearRecordingDays){
            errors.ClearRecordingDays = this.props.t('IsNotInteger')
        }else{
            errors.ClearRecordingDays = false
        }

        
        return errors
    }

    checkErrors(){
        let error = this.state.errors.ClearDataDays || 
                    this.state.errors.ClearRecordingDays

        return error
    }


    render(){
        const {t} = this.props

        const title = t('LogSettings')

        const margin = {margin:'16px 0 8px 0'}

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:400}}>


            <Box textAlign="left" style={{...margin, width: '100%'}}>

                <Grid container justifyContent="flex-start"  >

                    <Grid xs={9} key="1" item style={{}}>

                        <FormControl>
                            <label>
                                <Checkbox color="primary" 
                                    checked={this.state.logSettings.ClearData}
                                    onChange={this.handleInput}
                                    name="ClearData"
                                    />
                                    {t('ClearDataOlder')}
                            </label>
                        </FormControl>

                    </Grid>

                    <Grid xs={3} key="2" item style={{}}>

                        <TextField name="ClearDataDays"  margin="normal"
                            style={{width: '50%', margin:0}}
                            size="small"
                            autoComplete="new-password"
                            error={this.state.errors.ClearDataDays!==false}
                            value={this.state.logSettings.ClearDataDays}
                            onChange={this.handleInput.bind(this)}
                        />

                        <span style={{marginTop:10, display:'inline-block' }}>({t('days')})</span>

                    </Grid>

                </Grid>
                
            </Box>

            <Box textAlign="left" style={{...margin, width: '100%'}}>

                <Grid container justifyContent="flex-start"  >

                    <Grid xs={9} key="1" item style={{}}>

                        <FormControl>
                            <label>
                                <Checkbox color="primary" 
                                    checked={this.state.logSettings.ClearRecordings}
                                    onChange={this.handleInput}
                                    name="ClearRecordings"
                                    />
                                    {t('ClearVoiceAndVideoRecordingsOlder')}
                            </label>
                        </FormControl>

                    </Grid>

                    <Grid xs={3} key="2" item style={{}}>

                        <TextField name="ClearRecordingDays"  margin="normal"
                            style={{width: '50%', margin:0}}
                            size="small"
                            autoComplete="new-password"
                            error={this.state.errors.ClearRecordingDays!==false}
                            value={this.state.logSettings.ClearRecordingDays}
                            onChange={this.handleInput.bind(this)}
                        />

                        <span style={{marginTop:10, display:'inline-block' }}>({t('days')})</span>

                    </Grid>

                </Grid>
                
            </Box>

            
        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditLogSettingsDialog = withTranslation()(EditLogSettingsDialog_);